import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2 lg:grid-cols-4 gap-3 justify-start py-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertCard = _resolveComponent("AlertCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.active !== _ctx.EAlertState.PENDENTE)
      ? (_openBlock(), _createBlock(_component_AlertCard, {
          key: 0,
          vediLink: {name:'RichiamaEntro'},
          class: "h-24",
          titolo: "Stato ok",
          numero: _ctx.ok,
          "colore-stato-class": "text-next-atp md:text-xl text-lg translate-y-1/5"
        }, null, 8, ["numero"]))
      : _createCommentVNode("", true),
    (_ctx.active !== _ctx.EAlertState.SCADUTO)
      ? (_openBlock(), _createBlock(_component_AlertCard, {
          key: 1,
          vediLink: {name:'AlertScaduti'},
          class: "h-24",
          titolo: "Alert scaduti",
          numero: _ctx.scaduti,
          "colore-stato-class": "text-next-orange md:text-xl text-lg translate-y-1/5"
        }, null, 8, ["numero"]))
      : _createCommentVNode("", true),
    (_ctx.active !== _ctx.EAlertState.IN_SCADENZA)
      ? (_openBlock(), _createBlock(_component_AlertCard, {
          key: 2,
          vediLink: {name:'AlertScadenza'},
          class: "h-24",
          titolo: "Alert in scadenza",
          numero: _ctx.in_scadenza,
          "colore-stato-class": "text-next-pre md:text-xl text-lg translate-y-1/5"
        }, null, 8, ["numero"]))
      : _createCommentVNode("", true),
    _createVNode(_component_AlertCard, {
      vediLink: {name:'ListaClienti'},
      class: "h-24",
      titolo: "Clienti / Contatti",
      numero: `${_ctx.clienti}/${_ctx.contatti}`,
      "colore-stato-class": "text-next-bri md:text-xl text-lg translate-y-1/5"
    }, null, 8, ["numero"])
  ]))
}